<template>
    <section :id="id" :class="['s-slice', className]" v-bind="$attrs">
        <div class="a-container">
            <a-slice-header
                v-if="title || lead || bodyText"
                :title="title"
                :title-tag="titleTag"
                :lead="lead"
                :body-text="bodyText"
                :theme="theme"
            />
            <slot />
        </div>
    </section>
</template>

<script>
import ASliceHeader from '@core/components/slice-header/slice-header.vue';
import contentMixin from '@core/mixins/content.js';
import styleMixin from '@core/mixins/style.js';
import { LAYOUTS } from '@model/slices/basic-slice.js';

export default {
    name: 'SBasicSlice',

    components: {
        ASliceHeader,
    },

    mixins: [contentMixin, styleMixin],

    inheritAttrs: false,

    props: {
        theme: {
            type: String,
            default: 'light',
        },

        layout: {
            type: String,
            default: null,
            validator: (value) => value === null || LAYOUTS.includes(value),
        },
    },

    computed: {
        className() {
            return {
                ...this.basicClassName,
                [ `is-${this.theme}`]: this.theme,
                [`s-slice_layout_${this.layout}`]: this.layout,
            };
        },
    },
};
</script>

<style lang="postcss">
.s-slice {
    @mixin basic-slice-paddings;
    @mixin border-top;
    @mixin border-bottom;

    &_background {
        @mixin background;
    }

    &_layout_row {
        @media (--viewport-desktop) {
            & .a-container {
                display: flex;
            }

            & .a-slice-header {
                width: calc((100% - 48px) / 4);
                flex-shrink: 0;
                padding-inline-end: 16px;
                margin-inline-end: 16px;
            }
        }
    }
}
</style>
